import React from 'react';

import GraphBox from '../ContentBox/GraphBox';
import './ReportView.scss';
import ParameterFilter from '../VariableView/Filter/ParameterFilter';

import Loader from '../Loader/Loader';
import {
  getOMIGraphDataQuery,
  getInSituGraphData,
  getRangeGraphData,
  get3DViewGraphData,
} from '../../services/api';

import { FLAG, SEEN } from '../BulletinView/constantes';

class ReportView extends React.Component {
  constructor() {
    super();
    this.state = {
      graphsByUrl: {},
      isLoading: false,
      graphStatus: null,
    };
    this.updateGraphStatus = this.updateGraphStatus.bind(this);
  }

  componentDidMount() {
    const { reportToDisplay, updateEntryStatus } = this.props;
    this.fetchGraphData();
    this.generateGraphStatus();
    updateEntryStatus(reportToDisplay, { isUnseen: false });
  }

  async fetchGraphData() {
    const { reportToDisplay } = this.props;
    this.setState({ isLoading: true });

    const graphPromises = reportToDisplay.graphs.map(async graph => {
      const [baseURL, searchURL] = graph.url.split('?');
      const graphType = baseURL.split('/').slice(-1)[0];
      const parsedSearch = new URLSearchParams(searchURL);
      const urlActiveFilters = JSON.parse(parsedSearch.get('activeFilters'));

      try {
        switch (graphType) {
          case 'range': {
            const rangeData = await getRangeGraphData(urlActiveFilters, {});
            this.setState(({ graphsByUrl: prevGraphsByUrl }) => ({
              graphsByUrl: {
                ...prevGraphsByUrl,
                [`${graph.url}-data`]: rangeData,
              },
            }));
            break;
          }

          case 'in-situ': {
            const inSituData1 = await getInSituGraphData(urlActiveFilters);
            const filtersData = urlActiveFilters.map(currentFilter => ({
              ...currentFilter,
              stat: 1,
            }));
            const inSituData2 = await getInSituGraphData(filtersData);

            this.setState(({ graphsByUrl: prevGraphsByUrl }) => ({
              graphsByUrl: {
                ...prevGraphsByUrl,
                [`${graph.url}-data`]: inSituData1,
                [`${graph.url}-data2`]: inSituData2,
              },
            }));
            break;
          }

          case 'tz-view': {
            const tzViewData = await get3DViewGraphData(urlActiveFilters);
            this.setState(({ graphsByUrl: prevGraphsByUrl }) => ({
              graphsByUrl: {
                ...prevGraphsByUrl,
                [`${graph.url}-data`]: tzViewData,
              },
            }));
            break;
          }

          case 'omi': {
            const omiData = await getOMIGraphDataQuery(urlActiveFilters, {});
            this.setState(({ graphsByUrl: prevGraphsByUrl }) => ({
              graphsByUrl: { ...prevGraphsByUrl, [`${graph.url}`]: omiData },
            }));
            break;
          }

          default:
            throw new Error(
              'Error with one of the given URLs. Please correct the report configuration.',
            );
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('An error occurred while fetching graph data:', err);
        throw new Error(err);
      }
    });

    try {
      await Promise.all(graphPromises);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('An error occurred while fetching graph data:', error);
    }

    this.setState({ isLoading: false });
  }

  generateGraphStatus() {
    const { reportToDisplay } = this.props;
    const graphStatus = {};
    reportToDisplay.graphs.forEach(({ id, status }) => {
      graphStatus[id] = status === FLAG ? FLAG : SEEN;
    });
    this.setState({ graphStatus });
  }

  updateGraphStatus(graph, comment, isFlagged) {
    const { updateEntryStatus, reportToDisplay } = this.props;
    let nextGraphStatus = {};
    // update the mapStatus
    this.setState(({ graphStatus: prevGraphStatus }) => {
      nextGraphStatus = {
        ...prevGraphStatus,
        [graph.id]: isFlagged ? FLAG : SEEN,
      };
      return {
        graphStatus: nextGraphStatus,
      };
    });
    if (isFlagged) {
      updateEntryStatus(reportToDisplay, { isFlagged: true });
    } else if (
      nextGraphStatus &&
      !Object.values(nextGraphStatus).includes(FLAG)
    ) {
      // remove flag icon in the menu if there is not flagged graph anymore
      updateEntryStatus(reportToDisplay, { isFlagged: false });
    }
  }

  render() {
    const {
      bulletinDate,
      reportToDisplay,
      disableFlag,
      userIsAuthenticated,
      prevEntryLink,
      nextEntryLink,
      validationEnabled,
    } = this.props;

    const { graphsByUrl, graphStatus, isLoading } = this.state;

    if (isLoading || !graphStatus) {
      return <Loader>Loading content...</Loader>;
    }

    return (
      <div>
        <ParameterFilter
          nextEntryLink={nextEntryLink}
          prevEntryLink={prevEntryLink}
        />
        <div className="graphs">
          {reportToDisplay &&
            reportToDisplay.graphs &&
            reportToDisplay.graphs.map(graph => (
              <GraphBox
                key={graph.id}
                content={graph}
                status={graphStatus[graph.id]}
                FLAG_CODE={FLAG}
                SEEN_CODE={SEEN}
                disableFlag={!userIsAuthenticated || disableFlag}
                data={
                  graphsByUrl[graph.url]
                    ? [graphsByUrl[graph.url]]
                    : [
                        graphsByUrl[`${graph.url}-data`],
                        graphsByUrl[`${graph.url}-data2`],
                      ]
                }
                updateFlagMenu={this.updateGraphStatus}
                userIsAuthenticated={userIsAuthenticated}
                bulletinDate={bulletinDate}
                validationEnabled={validationEnabled}
              />
            ))}
        </div>
      </div>
    );
  }
}

export default ReportView;
